module.exports = __webpack_public_path__ + "static/media/02.5f464d93.png";